import { set as setCookie } from "../js/utils/cookie/cookie";
import { COOKIES, EVENTS } from "../js/constants";

export default class DonationFormEntryPoints {
  /**
   * Creates a tracking instance that handles all entrypoints to the donation form.
   */
  constructor() {
    this.config = {
      selectors: {
        ctaHeader: ".Tracking--donationCtaHeader",
        ctaContent:
          ".Tracking--buttons:not(.Tracking--overlayTeaserButtons) .FskButton--donation",
        donationFooter: ".Tracking--donationTextLinkFooter",
        overlayTeaser: ".Tracking--overlayTeaser",
        overlayTeaserDonation:
          ".Tracking--overlayTeaserButtons .FskButton--donation",
      },
    };

    this._init();
    this._asyncInit();
  }

  /**
   * inits for elements that are already mounted
   *
   * @private
   */
  _init() {
    const entrypoints = [
      {
        selector: this.config.selectors.ctaHeader,
        action: "cta header",
      },
      {
        selector: this.config.selectors.ctaContent,
        action: "cta content",
      },
      {
        selector: this.config.selectors.donationFooter,
        action: "text-link footer",
      },
    ];

    DonationFormEntryPoints._bindEvents(entrypoints);
  }

  /**
   * inits for elements that are loaded asynchronously
   * e.g. overlay teaser
   *
   * @private
   */
  _asyncInit() {
    const overlayTeaser = document.querySelector(
      this.config.selectors.overlayTeaser
    );

    if (overlayTeaser) {
      overlayTeaser.addEventListener(EVENTS.OVERLAY_INIT, () => {
        const entrypoints = [
          {
            selector: this.config.selectors.overlayTeaserDonation,
            action: "cta overlay",
          },
        ];

        DonationFormEntryPoints._bindEvents(entrypoints);
      });
    }
  }

  /**
   * binds events for donation form entrypoints
   *
   * @param {Array} entrypoints
   * @private
   */
  static _bindEvents(entrypoints) {
    entrypoints.forEach((entrypoint) => {
      const elements = [...document.querySelectorAll(entrypoint.selector)];
      elements.forEach((element) => {
        element.addEventListener("click", () => {
          DonationFormEntryPoints._onClickOnEntryPoint(entrypoint.action);
        });
      });
    });
  }

  /**
   * handles click on donation form entrypoint
   *
   * @private
   * @static
   * @param {string} action
   */
  static _onClickOnEntryPoint(action) {
    DonationFormEntryPoints._trackData(action);
    DonationFormEntryPoints._storeDataToCookie(action);
  }

  /**
   * adds data to the data layer
   *
   * @private
   * @static
   * @param {string} action
   */
  static _trackData(action) {
    window.dataLayer.push({
      event: "Event",
      event_name: "spenden_teaser",
      spenden_teaser: {
        spenden_teaser_element: action,
        pp_event_category: "spenden teaser",
        pp_event_action: action,
        pp_event_name: undefined,
      },
    });
  }

  /**
   * stores data to a cookie
   * we want to track the entrypoint information in further steps as well (e.g. donation form)
   * we store it in a cookie for some time to transfer data from step to step
   *
   * @private
   * @static
   * @param {string} action
   */
  static _storeDataToCookie(action) {
    setCookie(COOKIES.DONATION_ENTRY_POINT, action, {
      path: "/",
      end: 60 * 60,
      SameSite: "Lax",
      secure: true,
    });
  }
}
